import React from 'react'
import PropTypes from 'prop-types'
import ColorPicker from 'components/forms/ColorPicker'
import FormBackgroundImage from 'components/forms/image/FormBackgroundImage'
import FormSelect from 'components/forms/bases/FormSelect'
import FormLabel from 'components/labels/FormLabel'
import FormSlider from 'components/forms/FormSlider'
import { updateObject } from 'helpers/objectHelpers'

const BackgroundSwitcher = ({
  refElement,
  value,
  value: {
    video = '',
    backgroundColor = '',
    backgroundImage = '',
    backgroundSize = '',
    // backgroundRepeat = '',
    // backgroundPosition = '',
    backgroundImageStyle = '',
    backgroundPositionX = '',
    backgroundPositionY = '',
    objectFit = '',
  },
  onChange,
}) => {
  const handleUpdate = (val, key) => onChange(updateObject(value, { [key]: val }))
  const handleUpdatePercentage = (val, key) => handleUpdate(`${val}%`, key)
  const strToInt = (str) => str.replace(/[^0-9]/g, '')
  const backgroundPositionXInteger = strToInt(backgroundPositionX)
  const backgroundPositionYInteger = strToInt(backgroundPositionY)
  return (
    <div style={{ padding: 15 }}>
      <ColorPicker
        label="Background Color"
        value={backgroundColor}
        onChange={(val) => handleUpdate(val, 'backgroundColor')}
      />
      <FormLabel
        style={{
          marginTop: 20,
          color: 'rgb(117, 117, 117)',
        }}
      >
        Background Image
      </FormLabel>
      <FormBackgroundImage
        isHorizontal
        source={backgroundImage}
        onChange={(source) => handleUpdate(source, 'backgroundImage')}
      />
      <FormSelect
        label="Background Image Style"
        options={
          ['Fill', 'Fit', 'Stretch', 'Tile']
        }
        value={backgroundImageStyle}
        onChange={(val) => handleUpdate(val, 'backgroundImageStyle')}
      />
      {
        (backgroundImageStyle === 'Fill' || backgroundImageStyle === 'Fit') &&
        <div>
          <FormSlider
            renderLabel={(x) => `Position-X ( ${x}%)`}
            value={backgroundPositionXInteger}
            onChange={(val) => handleUpdatePercentage(val, 'backgroundPositionX')}
          />
          <FormSlider
            renderLabel={(x) => `Position-Y ( ${x}%)`}
            value={backgroundPositionYInteger}
            onChange={(val) => handleUpdatePercentage(val, 'backgroundPositionY')}
          />
        </div>
      }
    </div>
  )
}

BackgroundSwitcher.propTypes = {
  value: PropTypes.object.isRequired,
}
BackgroundSwitcher.defaultProps = {}

export default BackgroundSwitcher



// WEBPACK FOOTER //
// ./src/components/Canvas/builder/components/panel/BackgroundSwitcher.js